import $ from 'jquery';

const SearchWidget = (() => {
  'use strict';

  const init = (fullTextSearch = false) => {
    const $select = $('select');
    const $searchSelect = $('.search-select');
    $select
      .not('.disable-select')
      .each((index, element) => {
        const $element = $(element);
        $element.addClass('ui selection dropdown search loaded-dropdown');
        const options = { fullTextSearch };

        if ($element.is('[data-dropdown-max-selections]')) {
          options.maxSelections = $element.data('dropdown-max-selections');
        }

        $element.dropdown(options);
      })
      .find('input.search')
      .on('focus', function () {
        $(this).attr('autocomplete', 'disabled');
      });

    $searchSelect.not('.disable-select').each((index, element) => {
      const $element = $(element);
      const options = {
        fullTextSearch: true,
      };

      if ($element.is('[data-clearable]')) {
        options.clearable = true;
      }

      $element.dropdown(options);

      $element.on('focus', function () {
        $(this).attr('autocomplete', 'disabled');
      });
    });

    $select.on('change', () => {
      initDropdownFiltering();
    });

    initDropdownFiltering();
  };

  const initDropdownFiltering = () => {
    $('.js__dropdown-filter-master').each((index, element) => {
      const $dropdownFilterMaster = $(element);
      const $dropdownFilterMasterSelect = $dropdownFilterMaster.find('select');
      const filterMap = $dropdownFilterMasterSelect.data('filter-map');
      const $dropdownFilterSlave = $dropdownFilterMaster
        .closest('.js__toggle-by-input-wrapper')
        .find('.js__dropdown-filter-slave');

      addDataAttributesToDropdownOptions($dropdownFilterSlave);
      toggleSelectOptions($dropdownFilterMasterSelect.val(), filterMap, $dropdownFilterSlave);
    });
  };

  const toggleSelectOptions = (val, filterMap, $dropdownFilterSlave) => {
    const $items = $dropdownFilterSlave.find('.menu .item');
    $items.each((index, element) => {
      const $item = $(element);

      $item.toggle(filterMap[String(val)].includes($item.data('code-type')));
    });
  };

  const addDataAttributesToDropdownOptions = $select => {
    const $options = $select.find('option').not('option[value=""]');

    $options.each((index, element) => {
      $($select.find('.menu .item')[Number(index)]).data($(element).data());
    });
  };

  return {
    init: init,
  };
})();

export default SearchWidget;
